import axios from 'axios';
import { Personagem } from '../../models/personagem';

class UsuarioService {
  serverPath = "/api/characters";

  apiURL = process.env.REACT_APP_API_URL;

  save(usuario){
    return axios.post(this.apiURL + this.serverPath,usuario)
  }

  getAllPaginated(page:number,limit:number){
    return axios.get(this.apiURL+ this.serverPath,{
      headers:{
        "page": page,
        "size": limit
      }
    })
  }

  delete(id){
    return axios.delete(this.apiURL + this.serverPath + "/" + id)
  }

  getById(id:number){
    return axios.get<Personagem>(`${this.apiURL}${this.serverPath}/${id}`)
  }


  update(id:number,personagem){
    return axios.put(`${this.apiURL}${this.serverPath}/${id}`,personagem)
  }

  search(formData: { origin: string; nome: string; status: string }) {
    return axios.get<Personagem[]>(`${this.apiURL}/api/characters/search`,{
      headers:{
        nome: formData.nome,
        land: formData.origin,
        status: formData.status
      }
    })
  }
}
export default UsuarioService;